import { render, staticRenderFns } from "./CardFood.vue?vue&type=template&id=617bd3e4"
import script from "./CardFood.vue?vue&type=script&lang=js"
export * from "./CardFood.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports